import React from 'react';

const NotFound = () => (
  <div style={{ padding: 40, textAlign: 'center' }}>
    <h1>Página no encontrada</h1>
    <p>La ruta que buscas no existe.</p>
    <a href="/#/">Volver a la tienda</a>
  </div>
);

export default NotFound; 